<template>
  <!-- Partners Section -->
  <section class="partners-section">
    <div class="container">
      <div class="row">
        <div class="col-md-12 text-center aos" data-aos="fade-up">
          <div class="section-heading">
            <h2>Our Partners</h2>
          </div>
        </div>
        <div class="owl-carousel partners-slider">
          <Carousel
            :autoplay="3000"
            :loop="true"
            :wrap-around="true"
            :settings="settings"
            :breakpoints="breakpoints"
          >
            <Slide v-for="item in indexpartners" :key="item.id">
              <div class="partner-img">
                <a href="javascript:void(0);">
                  <img :src="require(`@/assets/img/partner/${item.image}`)" alt="img" />
                </a>
              </div>
            </Slide>
            <template #addons>
              <Navigation />
            </template>
          </Carousel>
        </div>
      </div>
    </div>
  </section>
  <!-- Partners Section -->

  <!-- Blog Section -->
  <section class="blogs-section">
    <div class="container">
      <div class="row">
        <div class="col-md-12 text-center aos" data-aos="fade-up">
          <div class="section-heading">
            <h2>Latest Blog</h2>
            <p>Here’s a compelling blog description designed to attract readers and provide a clear idea
              of what they can expect from your blog:</p>
          </div>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-lg-4 col-md-6 d-flex">
          <div class="blog flex-fill aos" data-aos="fade-up">
            <div class="blog-image">
              <router-link to="/blogs/blog-details"><img class="img-fluid"
                  src="@/assets/img/providers/provider-23.jpg" alt="Post Image"></router-link>
            </div>
            <div class="blog-content mb-0">
              <ul class="blog-items">
                <li><i class="feather-calendar"></i>09 Aug 2025</li>
                <li>
                  <div class="post-author">
                    <a href="#"><i class="feather-user"></i><span>Adrian</span></a>
                  </div>
                </li>
              </ul>
              <h3 class="blog-title">
                <router-link to="/blogs/blog-details">Maximize Your Business Potential with the
                  Right Service</router-link>
              </h3>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 d-flex">
          <div class="blog flex-fill aos" data-aos="fade-up">
            <div class="blog-image">
              <router-link to="/blogs/blog-details"><img class="img-fluid"
                  src="@/assets/img/providers/provider-19.jpg" alt="Post Image"></router-link>
            </div>
            <div class="blog-content mb-0">
              <ul class="blog-items">
                <li><i class="feather-calendar"></i>05 Aug 2025</li>
                <li>
                  <div class="post-author">
                    <a href="#"><i class="feather-user"></i><span>JohnDoe</span></a>
                  </div>
                </li>
              </ul>
              <h3 class="blog-title">
                <router-link to="/blogs/blog-details">Take Advantage of Trial Periods or
                  Consultations</router-link>
              </h3>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 d-flex">
          <div class="blog flex-fill aos" data-aos="fade-up">
            <div class="blog-image">
              <router-link to="/blogs/blog-details"><img class="img-fluid"
                  src="@/assets/img/providers/provider-31.jpg" alt="Post Image"></router-link>
            </div>
            <div class="blog-content mb-0">
              <ul class="blog-items">
                <li><i class="feather-calendar"></i>01 July 2025</li>
                <li>
                  <div class="post-author">
                    <a href="#"><i class="feather-user"></i><span>Josuva</span></a>
                  </div>
                </li>
              </ul>
              <h3 class="blog-title">
                <router-link to="/blogs/blog-details">Specific features and benefits of your
                  service marketplace.</router-link>
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
		<!-- /Blog Section -->

  <!-- App Section -->
  <section class="app-section">
    <div class="app-out-bg d-none d-md-block">
      <img src="@/assets/img/bg/spring-01.png" class="img-fluid" alt="bg">
    </div>
    <div class="container">
      <div class="app-sec pb-lg-0">
        <div class="app-bg-1 d-none d-lg-block">
          <img src="@/assets/img/bg/ellipse-01.png" class="img-fluid" alt="bg">
        </div>
        <div class="app-bg-2 d-none d-lg-block">
          <img src="@/assets/img/bg/ellipse-02.png" class="img-fluid" alt="bg">
        </div>
        <div class="app-bg-3 d-none d-md-block">
          <img src="@/assets/img/bg/dot-white.png" class="img-fluid" alt="bg">
        </div>
        <div class="row">
          <div class="col-lg-6 col-12">
            <div class="col-md-12">
              <div class="heading aos" data-aos="fade-up">
                <h2>Download Our App</h2>
                <p>
                  Whether you're looking to our app brings everything you need right
                  to your fingertips. Enjoy a smooth and intuitive experience designed
                  with you in mind.
                </p>
                <h6>Scan the QR code to get the app now</h6>
                <div class="scan-img">
                  <img src="@/assets/img/scan-img.png" class="img-fluid" alt="img">
                </div>
              </div>
            </div>
            <div class="downlaod-btn aos" data-aos="fade-up">
              <a href="javascript:void(0);">
                <img src="@/assets/img/icons/goolge-play.svg" alt="img">
              </a>
              <a href="javascript:void(0);">
                <img src="@/assets/img/icons/app-store.svg" alt="img">
              </a>
            </div>
          </div>
          <div class="col-lg-6 col-12">
            <div class="appimg-set aos d-none d-lg-block" data-aos="fade-up">
              <img src="@/assets/img/bg/phone.png" class="img-fluid" alt="img">
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- /App Section -->
</template>

<script>
import { Carousel, Pagination, Navigation, Slide } from "vue3-carousel";
import indexpartners from "@/assets/json/indexpartners.json";
import "vue3-carousel/dist/carousel.css";
export default {
  data() {
    return {
      indexpartners: indexpartners,
      settings: {
        itemsToShow: 1,
        snapAlign: "center",
      },

      breakpoints: {
        320: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        575: {
          itemsToShow: 2,
          snapAlign: "center",
        },
        // 700px and up
        767: {
          itemsToShow: 3.5,
          snapAlign: "center",
        },
        // 991px and up
        991: {
          itemsToShow: 4,
          snapAlign: "center",
        },
        // 1024 and up
        1024: {
          itemsToShow: 5,
          snapAlign: "start",
        },
      },
    };
  },
  components: {
    Carousel,
    Slide,
    Pagination,
    Navigation,
  },
};
</script>

<style>
.partner-img {
  margin-right: 24px;
}
</style>
